import { create } from "zustand";
import { Folder } from "./types";
import { ISidebarItem } from "@/components/common/sidebar/SidebarItem";
import { DataConfigurations } from "@/types";
import {
  CreativeReport,
  CreativeReportListItem,
  CreativeReportSection,
} from "../creatives/types";

export interface CommentAnalysisStore {
  selectedGroup: { key: string; label: string };
  folders: Folder[];
  selectedSidebarItem: ISidebarItem | null;
  setSelectedGroup: (group: { key: string; label: string }) => void;
  setFolders: (folders: Folder[]) => void;
  setSelectedSidebarItem: (item: ISidebarItem | null) => void;
  resetState: () => void;
}

export interface CompetitorReportStore {
  loadingReportList: boolean;
  reportList: CreativeReportListItem[];
  selectedReportItem: CreativeReportListItem | null;
  isReportLoading: boolean;
  selectedReport: CreativeReport | null;
  selectedReportSection: (CreativeReportSection & { overrideScroll?: boolean }) | null;
  dataConfiguration: DataConfigurations | null;
  isAutoSaving: boolean;
  setLoadingReportList: (loadingReportList: boolean) => void;
  setReportList: (reportList: CreativeReportListItem[]) => void;
  setSelectedReportItem: (selectedReportItem: CreativeReportListItem | null) => void;
  setSelectedReport: (report: CreativeReport | null) => void;
  setSelectedReportSection: (
    selectedReportSection: CreativeReportSection & { overrideScroll?: boolean },
  ) => void;
  setDataConfiguration: (dataConfiguration: DataConfigurations) => void;
  setIsReportLoading: (isReportLoading: boolean) => void;
  setIsAutoSaving: (isAutoSaving: boolean) => void;
  resetState: () => void;
}

export const useCompetitorReportStore = create<CompetitorReportStore>((set) => ({
  loadingReportList: false,
  reportList: [],
  selectedReportItem: null,
  isReportLoading: false,
  selectedReport: null,
  selectedReportSection: null,
  dataConfiguration: null,
  isAutoSaving: false,
  setLoadingReportList: (loadingReportList) => set({ loadingReportList }),
  setReportList: (reportList) => set({ reportList }),
  setSelectedReportItem: (selectedReportItem) => set({ selectedReportItem }),
  setSelectedReport: (selectedReport) => set({ selectedReport }),
  setSelectedReportSection: (selectedReportSection) => set({ selectedReportSection }),
  setDataConfiguration: (dataConfiguration) => set({ dataConfiguration }),
  setIsReportLoading: (isReportLoading) => set({ isReportLoading }),
  setIsAutoSaving: (isAutoSaving) => set({ isAutoSaving }),
  resetState: () =>
    set({
      loadingReportList: false,
      reportList: [],
      selectedReportItem: null,
      isReportLoading: false,
      selectedReport: null,
      selectedReportSection: null,
      dataConfiguration: null,
      isAutoSaving: false,
    }),
}));

export const useCommentAnalysisStore = create<CommentAnalysisStore>((set) => ({
  selectedGroup: { key: "overall", label: "Overall" },
  folders: [],
  selectedSidebarItem: null,
  setSelectedGroup: (group) => set({ selectedGroup: group }),
  setFolders: (folders) => set({ folders }),
  setSelectedSidebarItem: (item) => set({ selectedSidebarItem: item }),
  resetState: () =>
    set({
      selectedGroup: { key: "overall", label: "Overall" },
      folders: [],
      selectedSidebarItem: null,
    }),
}));
